import React, { Component } from 'react';
import './styles.scss';
import Asset from '../../requests/apa/Asset';
import { toggleNotification, setOverlayActive } from '../../actions/centerNotifications';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import Notification from './Notification';
import Device from '../../devices/device';
import { createBlurCanvas } from './blurCanvas';
import Utils from '../../utils/Utils';


class CenterNotification extends Component {
    constructor(props) {
        super(props);
        this.keys = Device.getDevice().getKeys();
        this.blockTimer = null;
        this.isTimerActive = false;
        this.state = {
            isNavigationBlocked: false
        };
        this.blurContainerRef = null;
    } 

    // Gestiona la sincronización del estado del Centro de Notificaciones con la fuente de login del usuario
    syncNotificationWithLoginSource = () => {
        const { userLoginSource, isOpen, toggleNotification } = this.props;

        // true -> desplegado, false -> replegado
        const notificationStateByLoginSource = {
            EXTERNAL_REGISTER: true,
            EXTERNAL_LOGIN: false,
            TELMEX_OOH_REGISTER: true,
            TELMEX_OOH_LOGIN: false,
            TELMEX_IP_REGISTER: true,
            TELMEX_IP_LOGIN: true
        };

        const shouldBeOpen = notificationStateByLoginSource[userLoginSource];

        // toggle, sólo si el estado actual de isOpen es diferente
        if (shouldBeOpen !== undefined && shouldBeOpen !== isOpen) {
            toggleNotification();
        }
    };
    
    componentDidMount() {
        // BACK en capture phase para interceptar siempre
        document.addEventListener('keydown', this.handleBackKey, true);
        // DOWN en bubble phase para que el hijo lo maneje primero
        document.addEventListener('keydown', this.handleDownKey, false);

        // Verificar si venimos de /profile
        const { location } = this.props;
        const currentPath = location ? location.pathname : null;
        const lastVisitedPath = sessionStorage.getItem('lastVisitedPath');

        // Solo activar cuando vienes de /profile hacia /node/homeuser
        if (lastVisitedPath === '/profile' && currentPath === '/node/homeuser') {
            this.syncNotificationWithLoginSource();

            const cnSpotlightTimeConfiguration = Utils.getRegionaliazedMetadata('cn_spotlight_time_configuration');
            const timeoutCNSpotlightTimeConfiguration = cnSpotlightTimeConfiguration && cnSpotlightTimeConfiguration.time_in_seconds ? cnSpotlightTimeConfiguration.time_in_seconds * 1000 : 5000;
        
            // Activar el bloqueo de navegación y el overlay
            this.setState({ isNavigationBlocked: true });
            this.toggleOverlay(true);
            this.isTimerActive = true;

            // Limpiar el lastVisitedPath para que no se reactive en futuras navegaciones
            sessionStorage.removeItem('lastVisitedPath');

            // Desactivar el bloqueo y el overlay después del tiempo configurado
            this.blockTimer = setTimeout(() => {
                this.setState({ isNavigationBlocked: false });
                this.toggleOverlay(false);
                this.isTimerActive = false;
            }, timeoutCNSpotlightTimeConfiguration);
        }
        this.initBlurCanvas();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.isOpen !== this.props.isOpen && !this.props.isOpen) {
            this.initBlurCanvas();
        }
    }

    componentWillUnmount() {
        document.removeEventListener('keydown', this.handleBackKey, true);
        document.removeEventListener('keydown', this.handleDownKey, false);
        if (this.blockTimer) {
            clearTimeout(this.blockTimer);
        }
        this.toggleOverlay(false);
    }

     deactivateOverlayAndBlocking = () => {
        // Limpiar el timer
        if (this.blockTimer) {
            clearTimeout(this.blockTimer);
            this.blockTimer = null;
        }
        
        // Desactivar el bloqueo y el overlay SIN transición (instantáneo)
        this.setState({ isNavigationBlocked: false });
        this.toggleOverlay(false, true); // skipTransition = true
        this.isTimerActive = false;
        
        // Cerrar la notificación
        if (this.props.isOpen) {
            this.props.toggleNotification();
        }
    }

    toggleOverlay = (showOverlay, skipTransition = false) => {
        const uxMain = document.getElementById('uxMain');
        if (uxMain) {
            if (skipTransition) {
                // Agregar clase para deshabilitar la transición temporalmente
                uxMain.classList.add('no-transition');
            }
            if (showOverlay) {
                uxMain.classList.add('notification-active');
            } else {
                uxMain.classList.remove('notification-active');
            }
            if (skipTransition) {
                // Forzar reflow para que se aplique sin transición
                void uxMain.offsetWidth;
                // Remover la clase después de un frame
                requestAnimationFrame(() => {
                    uxMain.classList.remove('no-transition');
                });
            }
        }
        // Actualizar el estado de Redux
        this.props.setOverlayActive(showOverlay);
    }

    initBlurCanvas = () => {
        var el = this.blurContainerRef;
        if (!el) return;

        // Limpiar canvas anterior
        while (el.firstChild) {
            el.removeChild(el.firstChild);
        }


        // Canvas con efecto blur por escalado
        const canvas = createBlurCanvas();
        el.appendChild(canvas);

        // Chevron encima del canvas
        const img = document.createElement('img');
        img.className = 'center-notification-chevron';
        img.src = Asset.get('Icono_ChevronArriba');
        img.alt = 'chevron-up';
        el.appendChild(img);
    }

    handleBackKey = (e) => {
        const currentKey = this.keys ? this.keys.getPressKey(e.keyCode) : null; 
        const { isOverlayActive } = this.props;
        
        // Solo manejar BACK cuando el overlay NO está activo
        if (currentKey === 'BACK' && !isOverlayActive && !this.state.isNavigationBlocked) {
            const { isOpen } = this.props;

            const activeElement = document.activeElement;
            const isButtonFocused = activeElement && 
                                    activeElement.classList.contains('notification-button');

            if (isOpen && isButtonFocused) {
                e.preventDefault();
                e.stopPropagation();
                this.props.toggleNotification();
            }
        } 
    }

    handleDownKey = (e) => {
        const currentKey = this.keys ? this.keys.getPressKey(e.keyCode) : null;  
        const { isOverlayActive } = this.props;
        
        // Solo manejar DOWN cuando el overlay NO está activo
        if (currentKey === 'DOWN' && !isOverlayActive && !this.state.isNavigationBlocked) {
            const { isOpen } = this.props;
            
            const activeElement = document.activeElement;
            const isButtonFocused = activeElement && 
                                    activeElement.classList.contains('notification-button');
            
            if (isOpen && isButtonFocused) {
                // Verificar si está en el último botón
                const allButtons = document.querySelectorAll('.notification-button');
                const currentIndex = Array.from(allButtons).indexOf(activeElement);
                
                // Solo colapsar si está en el último botón
                if (currentIndex === allButtons.length - 1) {
                    e.preventDefault();
                    e.stopPropagation();
                    this.props.toggleNotification();
                }
                // Si NO está en el último, el evento ya fue manejado por el hijo
            }
        }
    }

    render() {
        const { isOpen } = this.props;

        return (
            <div className='center-notification-container' style={{height: isOpen ? '15.46rem' : '4.26rem'}}>
                {isOpen 
                    ? <Notification 
                        isNavigationBlocked={this.state.isNavigationBlocked}
                        deactivateOverlayAndBlocking={this.deactivateOverlayAndBlocking}
                    />
                    : <div className='center-notification-closed' ref={function(el) { this.blurContainerRef = el; }.bind(this)}></div>
                }
            </div>
        )
    }
}

const mapStateToProps = (state) => ({
    isOpen: state.centerNotifications.isOpen,
    isOverlayActive: state.centerNotifications.isOverlayActive,
    userLoginSource: state && state.user && state.user.source,
});

const mapDispatchToProps = {
    toggleNotification,
    setOverlayActive
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CenterNotification));



// WEBPACK FOOTER //
// ./src/components/centerNotification/CenterNotification.jsx